module.exports = __webpack_public_path__ + "static/media/error_red.c54db602.svg";